import { RootState } from '../../../../redux/store';

export const selectChatSessionIds = (state: RootState) => state.chatSessions.allIds;
